<template>
	<el-row class="points-show">
		<!-- 顶部介绍栏 -->
		<el-col :span="24">
			<el-col :span="10">公告管理</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addAnnouncement(1)" plain>
					添加公告<i class="el-icon-add"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<!-- 搜索栏 -->
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>显示状态：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="searchform.status">
						<el-option v-for="(item, index) in reviewStatus" :key="index" :label="item.title"
							:value="item.type" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>关键字：</div>
					<el-input size="mini" v-model="searchform.content" placeholder="请输入关键字" clearable />
				</div>
			</el-col>
			<el-col :span="1" :offset="9">
				<el-button plain size="mini" type="primary" style="margin-left: 10px" @click="search">搜索</el-button>
				<el-button plain style="margin-left: 30px" size="mini" type="primary" @click="Empty">清空</el-button>
			</el-col>
		</el-row>
		<!-- table 数据列表 -->
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column type="index" width="30"></el-table-column>
				<!-- <el-table-column prop="name" label="公告主题" /> -->
				<el-table-column prop="content" label="公告标题" />
				<el-table-column prop="status" label="显示状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" type="success" size="mini">显示</el-tag>
						<el-tag v-if="scope.row.status == 1" type="warning" size="mini">隐藏</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="上传时间">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="230px">
					<template slot-scope="scope">
						<el-button plain size="mini" type="info" @click="addAnnouncement(2, scope.row)">编辑</el-button>
						<el-button plain type="danger" size="mini" @click="delAnnouncement(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<!-- 添加弹框 -->
		<el-dialog :title="isadd == 1 ? '创建计划' : '修改计划'" :visible.sync="dialogVisible" :before-close="closeUpdate"
			width="35%">
			<!-- 新增计划 -->
			<template v-if="isadd == 1">
				<el-form :model="addform" label-position="right" label-width="120px">
					<!-- <el-form-item label="公告主题:">
                <el-input size="mini" :rows="5" placeholder="请输入内容"  v-model="addform.title">
                </el-input>
            </el-form-item> -->
					<el-form-item label="公告标题:">
						<el-input size="mini" :rows="3" placeholder="请输入内容" v-model="addform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="addform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{item.title}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="公告详情">
						<wangeditor v-model="addform.contentInfo" style="width:100%;margin:0;" ref="wangeditor" />
					</el-form-item>
				</el-form>
			</template>

			<!-- 修改计划 -->
			<template v-else>
				<el-form :model="editform" label-position="right" label-width="120px">
					<el-form-item label="公告标题:">
						<el-input size="mini" :rows="3" placeholder="请输入内容" v-model="editform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="editform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{item.title}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="公告详情">
						<wangeditor v-model="editform.contentInfo" style="width:100%;margin:0;" ref="wangeditor" />
					</el-form-item>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addScattered()">确 定</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import wangeditor from '../../../components/wangEditor/wangEditor.vue';
	import httpClient from "../../../util/request.js";
	var vm;
	export default {
		components: {
			wangeditor
		},
		data() {
			return {
				status: '',
				content: '',
				pageSizes: [10, 20, 30, 40, 50],
				total: 0,
				tableHeight: window.innerHeight - 300,
				tableData: [],
				dialogVisible: false,
				isadd: -1,
				pageSize: 10,
				pageNum: 1,
				CategoryList: [],
				reviewStatus: [{
						title: "显示",
						type: 0,
					},
					{
						title: "隐藏",
						type: 1,
					}
				],
				editform: {
					id: '',
					title: '',
					content: '',
					contentInfo: ''
				},
				addform: {
					title: '',
					content: '',
					contentInfo: ''
				},
				searchform: {
					content: '',
					status: '',

				}
			};
		},
		mounted() {
			vm = this;
			this.getTable()
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			//获取数据列表
			getTable() {
				var data = {
					content: this.content,
					status: this.status,
				};
				this.$http
					.post(`/api/source/sysplannotice/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, data)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, '公告列表');
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},

			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},

			//搜索
			search() {
				this.content = this.searchform.content;
				this.status = this.searchform.status;
				this.pageNum = 1;
				this.getTable();
			},

			//清空
			Empty() {
				this.content = this.searchform.content = ''
				this.status = this.searchform.status = ''
				this.search();
			},

			//弹框取消
			closeUpdate() {
				(this.editform = {
					title: "",
					content: "",
					status: -1,
				}),
				(this.addform = {
					title: "",
					content: "",
					status: -1,
					id: '',
				}),
				(this.dialogVisible = false);
			},
			//召唤弹框
			addAnnouncement(type, val) {
				this.isadd = type
				if (type == 2) {
					//编辑数据赋值
					// this.editform.title= val.title
					this.editform.content = val.content
					this.editform.status = val.status
					this.editform.id = val.id
					this.editform.contentInfo = val.contentInfo
				}
				this.dialogVisible = true
			},
			//确定
			addScattered() {
				let _this = this;
				//添加
				if (this.isadd == 1) {
					if (
						!this.addform.contentInfo.trim() ||
						this.addform.status < 0 ||
						!this.addform.content.trim()
					) {
						return this.$message({
							type: "error",
							message: "请填写完整公告再提交~~",
						});
					}
					var data = {
						content: this.addform.content,
						status: this.addform.status,
						contentInfo: this.addform.contentInfo,
						deleteStatus: 0
					};

					this.$http
						.post(`/api/source/sysplannotice/insert`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加公告成功！！",
								});
								this.getTable();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isadd == 2) {
					var data = {
						content: this.editform.content,
						status: this.editform.status,
						id: this.editform.id,
						contentInfo: this.editform.contentInfo,
					};
					this.$http
						.post(`/api/source/sysplannotice/update`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改话术成功！！",
								});
								_this.closeUpdate();
								this.getTable();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},
			delAnnouncement(id) {
				this.$confirm('此操作将删除该条公告吗？, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysplannotice/deleteByPk/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTable()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			}
		},
	};
</script>

<style lang="less" scoped>
</style>
